import React from 'react';

export const NodeLogo = () => {
  return (
    <svg className="stack-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <title>Logo Node JS</title>
      <defs>
        <clipPath id="a64880b1-e2fb-4334-a29e-6abbc68d2e16">
          <path
            d="M40.8,41.5l-6.7,3.9a.7.7,0,0,0-.4.7v7.7a.7.7,0,0,0,.4.7l6.7,3.9a.6.6,0,0,0,.8,0l6.7-3.9a.7.7,0,0,0,.4-.7V46.1a.7.7,0,0,0-.4-.7l-6.7-3.9h-.8"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="e76c8639-e304-40c4-9cde-841e3202ab53"
          x1="-2263.81"
          y1="452.08"
          x2="-2263.62"
          y2="452.08"
          gradientTransform="matrix(-50.75, 103.54, 103.54, 50.75, -161656.17, 211481.14)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#3e863d" />
          <stop offset="0.5" stopColor="#55934f" />
          <stop offset="0.8" stopColor="#5aad45" />
        </linearGradient>
        <clipPath id="ab8b0e12-0511-4ea5-99e6-40f4b387224d">
          <path d="M33.8,54.3l.3.2,5.7,3.4,1,.5h.6l7.1-13h-.2l-4.4-2.6-2.3-1.3h-.2Z" fill="none" />
        </clipPath>
        <linearGradient
          id="b1906fe7-e6bc-4eef-a988-78265923af3e"
          x1="-2249.31"
          y1="426.98"
          x2="-2249.19"
          y2="426.98"
          gradientTransform="matrix(142.41, -105.22, -105.22, -142.41, 365278.62, -175815.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.57" stopColor="#3e863d" />
          <stop offset="0.72" stopColor="#619857" />
          <stop offset="1" stopColor="#76ac64" />
        </linearGradient>
        <clipPath id="ae09f03b-c1ab-4a10-b129-b111e41f339f">
          <path
            d="M41.1,41.4h-.3l-6.7,3.9,7.2,13.1h.3l6.7-3.9a.7.7,0,0,0,.4-.5L41.4,41.4h-.3"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id="bb7085c5-127d-4876-9883-7b8cf9554661"
          x1="-2241.53"
          y1="433.24"
          x2="-2241.42"
          y2="433.24"
          gradientTransform="matrix(129.89, 0, 0, -129.89, 291184.34, 56322.94)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.16" stopColor="#6bbf47" />
          <stop offset="0.38" stopColor="#79b461" />
          <stop offset="0.47" stopColor="#75ac64" />
          <stop offset="0.7" stopColor="#659e5a" />
          <stop offset="0.9" stopColor="#3e863d" />
        </linearGradient>
      </defs>
      <g id="b58063ae-b631-494f-975b-df0e6f6451bd" data-name="Layer 2">
        <g id="bb6df9f1-338d-49c5-8426-10a0e379ace4" data-name="Node">
          <circle
            id="ef7bc70f-e36f-4301-8285-d37ebae06f0a"
            data-name="Ellipse"
            cx="50"
            cy="50"
            r="50"
            fill="#ebebeb"
          />
          <g id="a757a3d0-f966-4375-85e2-e1a37796e856" data-name="green">
            <path
              d="M50,74.7a.7.7,0,0,1-.6-.2l-2.2-1.2c-.3-.2-.1-.3,0-.3l1-.4h.1l1.6,1h.2l6.4-3.7V62.3h-.1l-6.4-3.7h-.2l-6.3,3.7h-.1v7.6l1.7,1c1,.5,1.5-.1,1.5-.7V63a.2.2,0,0,1,.2-.2h.8a.2.2,0,0,1,.2.2v7.2a1.8,1.8,0,0,1-1.9,2,2.6,2.6,0,0,1-1.4-.4L43,70.9a1.5,1.5,0,0,1-.7-1.2V62.3a1.4,1.4,0,0,1,.7-1.1l6.4-3.7a1.5,1.5,0,0,1,1.3,0l6.4,3.7a1.4,1.4,0,0,1,.7,1.1v7.4a1.5,1.5,0,0,1-.7,1.2l-6.4,3.6a.8.8,0,0,1-.7.2"
              fill="#689f63"
            />
            <path
              d="M52,69.7c-2.8,0-3.4-1.3-3.4-2.4l.2-.2h.8a.2.2,0,0,1,.2.2c.2.8.5,1.2,2.2,1.2s1.9-.3,1.9-1-.1-.7-2.2-.9-2.8-.6-2.8-2,1-2,2.9-2,3,.7,3.1,2.2V65H53.7c-.2-.9-.6-1.2-2-1.2s-1.6.5-1.6.9.2.6,2.2.9,2.9.6,2.9,2S54,69.7,52,69.7m7.8-7.8H60a.2.2,0,0,0,.2-.2c0-.2-.1-.2-.2-.2h-.2Zm-.3-.6H60c.1,0,.5,0,.5.3s-.2.3-.3.4.2.1.2.3a1,1,0,0,0,.1.3h-.3v-.4h-.4v.5h-.3Zm-.6.6A1.1,1.1,0,0,0,60,63a1.1,1.1,0,0,0,1-1.1,1.1,1.1,0,0,0-1-1,1.1,1.1,0,0,0-1.1,1m2.3,0A1.3,1.3,0,0,1,60,63.2a1.3,1.3,0,0,1-1.3-1.3A1.3,1.3,0,0,1,60,60.7a1.3,1.3,0,0,1,1.2,1.2"
              fill="#689f63"
            />
            <path
              d="M78.1,48.3h.2l1.3.7v1.7h0l-1.3.7c-.1.1-.1.1-.2,0l-1.3-.7h-.1V49.2c0-.1.1-.1.1-.2Z"
              fill="#689f63"
              fillRule="evenodd"
            />
          </g>
          <path
            id="b35fc1ff-daea-4959-b2b7-998625a6bfd9"
            data-name="black"
            d="M30.3,45.9a.9.9,0,0,0-.4-.7l-6.8-3.9h-.8l-6.7,3.9a.9.9,0,0,0-.4.7V56.4a.5.5,0,0,0,.2.4h.4l4-2.3a.8.8,0,0,0,.4-.7V48.9a.8.8,0,0,1,.4-.7l1.7-1h.8l1.8,1a.8.8,0,0,1,.4.7v4.9a.8.8,0,0,0,.4.7l4,2.3h.4a.5.5,0,0,0,.2-.4Zm31.9,5.5c0,.1,0,.1-.1.2l-2.3,1.3h-.2l-2.4-1.3c0-.1-.1-.1-.1-.2V48.7c0-.1.1-.1.1-.2l2.4-1.3h.2l2.3,1.3c.1.1.1.1.1.2Zm.6-19.8a.3.3,0,0,0-.4,0c-.1,0-.2.2-.2.3V42.3c0,.1,0,.2-.1.2a.2.2,0,0,1-.3,0l-1.7-.9a.6.6,0,0,0-.8,0l-6.8,3.9a.8.8,0,0,0-.4.7V54a1,1,0,0,0,.4.7l6.8,3.9a1.1,1.1,0,0,0,.8,0l6.8-3.9a1,1,0,0,0,.4-.7V34.5a.8.8,0,0,0-.5-.7Zm22.5,17a.7.7,0,0,0,.4-.7V46.1a.9.9,0,0,0-.4-.8l-6.7-3.9a1.1,1.1,0,0,0-.8,0L71,45.3a1.2,1.2,0,0,0-.4.8v7.8a1.3,1.3,0,0,0,.4.7l6.8,3.8a1.1,1.1,0,0,0,.8,0l4-2.3c.1,0,.2-.2.2-.3a.5.5,0,0,0-.2-.4l-6.8-3.9c-.1,0-.2-.2-.2-.3V48.7c0-.1.1-.3.2-.3l2.1-1.2c.2-.1.3-.1.4,0l2.2,1.2c.1,0,.2.2.2.3v2c0,.1,0,.2.2.3s.2.1.4,0Z"
            fill="#333"
            fillRule="evenodd"
          />
          <g clipPath="url(#a64880b1-e2fb-4334-a29e-6abbc68d2e16)">
            <path
              d="M55.5,44.7,36.6,35.4,26.9,55.2l18.9,9.3Z"
              fill="url(#e76c8639-e304-40c4-9cde-841e3202ab53)"
            />
          </g>
          <g clipPath="url(#ab8b0e12-0511-4ea5-99e6-40f4b387224d)">
            <path
              d="M25.7,47.5,39,65.6,56.7,52.5,43.3,34.4Z"
              fill="url(#b1906fe7-e6bc-4eef-a988-78265923af3e)"
            />
          </g>
          <g clipPath="url(#ae09f03b-c1ab-4a10-b129-b111e41f339f)">
            <path
              d="M34.1,41.4V58.5H48.7V41.4Z"
              fill="url(#bb7085c5-127d-4876-9883-7b8cf9554661)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
